import React from 'react';
import classes from './source/warehouseSource/common.module.scss';

interface DocLinkLabelProps {
  description: string;
  linkRef: string;
  linkText?: string;
  insidePopover?: boolean;
}

const DocLinkLabel: React.FC<DocLinkLabelProps> = ({
  description,
  linkRef,
  linkText,
  insidePopover,
}: DocLinkLabelProps) => (
  <div className={insidePopover ? classes.doc_link_container : 'alert alert-secondary'}>
    {description}
    &nbsp;
    <a
      href={linkRef}
      className={insidePopover ? classes.link : 'alert-link'}
      target="_blank"
      rel="noreferrer"
    >
      <u>{linkText || 'here'}</u>
    </a>
    .
  </div>
);
export default DocLinkLabel;
